import { Injectable } from '@angular/core';
import { ModelModalReturnValue } from '@models-global/model-modal-return-value';
import { ContactCeModalComponent } from '@module-claims/components/contact-ce-modal/contact-ce-modal.component';
import { ClaimsCEsContactParams } from '@module-claims/models/claim-ce.interface';
import { IClaimsGroupClaimV2 } from '@module-claims/models/claims-group.interface';
import {
  ClaimCEContactModalState,
  IClaimCEContactModalState
} from '@module-claims/store/claim-ce-contact-modal.state';
import { Select } from '@ngxs/store';
import { DialogService } from '@progress/kendo-angular-dialog';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

type ClaimCEContactModalReturn = ModelModalReturnValue<ClaimsCEsContactParams>;

@Injectable()
export class ClaimCEContactModalService {
  @Select(ClaimCEContactModalState)
  stateModal$!: Observable<IClaimCEContactModalState>;

  constructor(private _dialogService: DialogService) {}

  open(
    claims: IClaimsGroupClaimV2[],
    title = 'Contact CE(s)'
  ): Observable<ClaimCEContactModalReturn> {
    const modalRef = this._dialogService.open({
      title,
      content: ContactCeModalComponent
    });
    modalRef.content.instance.claims = claims;

    const data$ = new Subject<ClaimCEContactModalReturn>();
    this.stateModal$.pipe(filter((data) => !!data)).subscribe((data) => {
      data$.next({
        action: data.action,
        data: data.data,
        modalRef
      });
    });

    return data$;
  }
}
